import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="px-6 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          大家都在讨论的热门综艺话题
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((topic) => (
            <a
              key={topic.id}
              href="#index"
              className="group flex items-center gap-3 px-5 py-3 rounded-full bg-background-100 hover:bg-background-200 transition-all cursor-pointer"
            >
              <span className={`w-9 h-9 rounded-full ${topic.color} flex items-center justify-center group-hover:scale-110 transition-transform`}>
                <i className={`${topic.icon} text-white text-sm`}></i>
              </span>
              <div className="text-left">
                <div className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{topic.name}</div>
                <div className="text-xs text-foreground-500">{topic.heat}</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}